import { Link, useLocation } from 'react-router-dom'
import { useLanguage } from '@/i18n/LanguageContext'

export default function NotFoundPage() {
  const location = useLocation()
  const { t } = useLanguage()
  const copy = t.notFound

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-8xl font-bold text-gray-200">404</h1>
        <h2 className="text-2xl font-semibold text-gray-900 mt-4">
          {copy.title}
        </h2>
        <p className="text-gray-600 mt-2 max-w-md mx-auto">
          {copy.message.replace('{path}', location.pathname)}
        </p>
        <div className="mt-8 space-x-4">
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-terracotta text-cream font-medium rounded-lg hover:bg-terracotta/90 transition-colors"
          >
            {copy.goHome}
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-block px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            {copy.goBack}
          </button>
        </div>
      </div>
    </div>
  )
}
